import { Area } from './area';

export interface FloorplanForm {
  name: string;
  description: string;
  imageUrl: string;
  menuPdf: Blob;
}

export interface Floorplan {
  eventId?: string;
  floorplanId?: string;
  name: string;
  description: string;
  imageUrl: string;
  areas: Area[];
  menuUrl?: string;
  menuFilename?: string;
  menuPdf?: string;
}

export interface FloorplanResponse {
  id: string;
  eventId?: string;
  name: string;
  description: string;
  imageUrl: string;
  areas: Area[];
  menuUrl: string;
  menuFilename?: string;
}

export const EMPTY_FLOORPLAN: Floorplan = {
  name: '',
  description: '',
  floorplanId: '',
  imageUrl: '',
  eventId: '',
  areas: [],
  menuFilename: '',
  menuUrl: '',
};
